import axios from "axios";
import { ReqMethods, ResponseStatus } from "../enums";
// import { setNotification, useNotifcation } from "context/notification";
import { useAuth, useLogout } from "./auth";
import env from "../config/env";

const BASE_URL = `${process.env.REACT_APP_API_URL}/v1`;

function useServiceHandler() {
  // const [, dispatch] = useNotifcation();

  return (fn) =>
    async (method, path, { query, payload, token, apiKey, toaster, message, error } = {}) => {
      try {
        const res = await fn(method, path, { query, payload, token, apiKey });
        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: message || res.data.message,
        //     title: "Success",
        //   });

        return { response: res.data };
      } catch (err) {
        // expire error : jwt expired
        if (err.response && err.response.status === ResponseStatus.UNAUTHORIZED) {
          // setNotification(dispatch, {
          //   open: true,
          //   message: error || "session expired",
          //   title: "Error",
          //   severity: "error",
          // });
          // setTimeout(Logout, 4000);
          return { error: err.response?.data || err };
        }

        const customError = err.response?.data?.error
          ? `${err.response?.data?.message} \n${err.response?.data?.error}`
          : err.response?.data?.message;

        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: error || customError || err.message,
        //     severity: "error",
        //     title: "Error",
        //   });
        return { error: err.response ? err.response.data : err };
      }
    };
}

function useCallService() {
  const authToken = 'useAuth()';
  const serviceHandler = useServiceHandler();

  const CallService = (method, path, { query, payload, token = true, apiKey = null }) => {
    const pathname = query ? `${path}?${query}` : path;
    const config = {};

    if (token) config.headers = { "x-auth-token": `Bearer ${authToken || token}` };
    if (apiKey) config.headers = { apiKey };

    const details = {};

    if (payload) details.payload = payload;
    details.config = config;

    return axios[method](pathname, ...Object.values(details));
  };

  return serviceHandler(CallService);
}

function useAppServices() {
  const { GET, POST, PUT, DELETE } = ReqMethods;
  const CallService = useCallService();

  /**
    Option for service is the object that could has the following properties
    query, payload, token, apiKey
  */

  const APIs = {

    // agency: {
    //   get: (options) => CallService(GET, `${BASE_URL}/agency/bycompany`, options),
    //   update_by_company_id: (options) => CallService(PUT, `${BASE_URL}/agency/update_by_company_id`, options),
    // },
    auth: {
      login: (options) => CallService(POST, `${BASE_URL}/auth/app/login`, options),
      signup: (options) => CallService(POST, `${BASE_URL}/auth/app/register`, options),
      integrationAppSignup: (options) => CallService(POST, `${BASE_URL}/auth/app/integration-signup`, options),
      customFields: (options) => CallService(POST, `${BASE_URL}/auth/custom_fields`, options),
      verifyEmail: (options) => CallService(POST, `${BASE_URL}/auth/app/verify-email`, options),
      resendEmail: (options) => CallService(POST, `${BASE_URL}/auth/app/resend-verify`, options),
      customuser: (options) => CallService(POST, `${BASE_URL}/auth/customuser`, options),
      updateLocationAfterSignup: (options) => CallService(PUT, `${BASE_URL}/auth/app/update-location`, options),
      addNewActiveLocation: (options) => CallService(PUT, `${BASE_URL}/auth/app/update-new-location`, options),
      integrationAppLogin: (options) => CallService(POST, `${BASE_URL}/auth/app/integration-signin`, options),
    },
    user: {
      getchatuser: (options) => CallService(GET, `${BASE_URL}/user/getchatuser`, options),
      get: (options) => CallService(GET, `${BASE_URL}/user`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/user/filter`, options),
      register: (options) => CallService(POST, `${BASE_URL}/user/register`, options),
      add_team: (options) => CallService(POST, `${BASE_URL}/user/add_team `, options),
      location_user: (options) => CallService(GET, `${BASE_URL}/user/location_user`, options),
      subscriber: (options) => CallService(GET, `${BASE_URL}/user/subscriber`, options),
      agency_user: (options) => CallService(GET, `${BASE_URL}/user/agency_user`, options),
      api_key: (options) => CallService(POST, `${BASE_URL}/user/create/api-key`, options),
      set_password: (options) => CallService(POST, `${BASE_URL}/user/set-password`, options),
    },
    roles: {
      create: (options) => CallService(POST, `${BASE_URL}/roles`, options),
      get: (options) => CallService(GET, `${BASE_URL}/roles`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/roles`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/roles`, options),
    },
    brand: {
      get: (options) => CallService(GET, `${BASE_URL}/brand`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/brand`, options),
      create: (options) => CallService(POST, `${BASE_URL}/brand`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/brand/filter`, options),
    },
    app: {
      get: (options) => CallService(GET, `${BASE_URL}/app`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/app`, options),
      create: (options) => CallService(POST, `${BASE_URL}/app`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/app`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/app/filter`, options),
    },
    offer: {
      get: (options) => CallService(GET, `${BASE_URL}/offer`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/offer`, options),
      create: (options) => CallService(POST, `${BASE_URL}/offer`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/offer`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/offer/filter`, options),
    },
    accounts: {
      get: (options) => CallService(GET, `${BASE_URL}/accounts`, options),
      getbyid: (options) => CallService(GET, `${BASE_URL}/accounts/getbyid`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/accounts`, options),
      AddBalance: (options) => CallService(PUT, `${BASE_URL}/accounts/addbalance`, options),
      getBalance: (options) => CallService(POST, `${BASE_URL}/accounts/getBalance`, options),
      getBalanceLogs: (options) => CallService(POST, `${BASE_URL}/accounts/getBalanceLogs`, options),
      create: (options) => CallService(POST, `${BASE_URL}/accounts`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/accounts`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/accounts/filter`, options),
      agencysaas: (options) => CallService(POST, `${BASE_URL}/accounts/agencysaas`, options),
      subscribplan: (options) => CallService(POST, `${BASE_URL}/accounts/subscribplan`, options),
      save_account_token: (options) => CallService(POST, `${BASE_URL}/accounts/save_account_token`, options),
      create_busines_account: (options) => CallService(POST, `${BASE_URL}/accounts/create_busines_account`, options),
      checkslackconnection: (options) => CallService(GET, `${BASE_URL}/accounts/checkslackconnection`, options),
      fetchSlackconnection: (options) => CallService(GET, `${BASE_URL}/accounts/fetchslackconnection`, options),
      updateSlackconnection: (options) => CallService(POST, `${BASE_URL}/accounts/updateSlackconnection`, options),
      findaccounts: (options) => CallService(POST, `${BASE_URL}/accounts/checkidofaccountagencyconfig`, options),
      findAccountByLocation: (options) => CallService(POST, `${BASE_URL}/accounts/check-location`, options),
      updateGHLTokens: (options) => CallService(PUT, `${BASE_URL}/accounts/update-ghl-tokens`, options),
      AddBalance: (options) => CallService(POST, `${BASE_URL}/accounts/add-balance`, options),
      purchaseAITokens: (options) => CallService(POST, `${BASE_URL}/accounts/purchase-ai-tokens`, options),
      getAITokenPurchases: (options) => CallService(POST, `${BASE_URL}/accounts/ai-token-purchases`, options),
    },
    free_account_template: {
      get: (options) => CallService(GET, `${BASE_URL}/free_account_template`, options),
      create: (options) => CallService(POST, `${BASE_URL}/free_account_template`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/free_account_template`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/free_account_template`, options),
    },
    users: {
      get: (options) => CallService(GET, `${BASE_URL}/users`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/users`, options),
      create: (options) => CallService(POST, `${BASE_URL}/users`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/users`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/users/filter`, options),
      onboarding: (options) => CallService(POST, `${BASE_URL}/users/onboarding`, options),
      updateUser: (options) => CallService(PUT, `${BASE_URL}/users/userId`, options),
      getGuardrails: (options) => CallService(GET, `${BASE_URL}/users/guardrails/${options.profileId}`, options),
      updateGuardrails: (options) => CallService(POST, `${BASE_URL}/users/guardrails/${options.profileId}`, options),
    },
    newsfeed: {
      get: (options) => CallService(GET, `${BASE_URL}/feeds`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/feeds`, options),
      create: (options) => CallService(POST, `${BASE_URL}/feeds`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/feeds`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/feeds/filter`, options),
    },
    stripe: {
      filter: (options) =>
        CallService(GET, `${BASE_URL}/agency/stripe/filter/${options.id}`, options),
      integrateAcocunt: (options) =>
        CallService(GET, `${BASE_URL}/agency/stripe/integrate`, options),
      get: (options) => CallService(GET, `${BASE_URL}/agency/stripe`, options),
      invoices: (options) =>
        CallService(GET, `${BASE_URL}/agency/stripe/invoices/${options.id}`, options),
      update: (options) =>
        CallService(POST, `${BASE_URL}/agency/stripe/update/${options.id}`, options),
      create: (options) => CallService(POST, `${BASE_URL}/agency/stripe/submit`, options),
      delete: (options) =>
        CallService(POST, `${BASE_URL}/agency/stripe/delete/${options.id}`, options),
    },
    notes: {
      get: (options) => CallService(GET, `${BASE_URL}/notes`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/notes`, options),
      create: (options) => CallService(POST, `${BASE_URL}/notes`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/notes/filter`, options),
    },
    reports: {
      customer: (options) => CallService(GET, `${BASE_URL}/reports/customer`, options),
      type_campaigns: (options) => CallService(GET, `${BASE_URL}/reports/type_campaigns`, options),
      transactions: (options) => CallService(GET, `${BASE_URL}/reports/transactions`, options),
      campaign: (options) => CallService(GET, `${BASE_URL}/reports/campaigns`, options),
      campaign_overview: (options) =>
        CallService(GET, `${BASE_URL}/reports/campaign_overview`, options),
      brand: (options) => CallService(GET, `${BASE_URL}/reports/brand`, options),
      agency: (options) => CallService(GET, `${BASE_URL}/reports/agency`, options),
      monthly_sale: (options) => CallService(GET, `${BASE_URL}/reports/monthly_sale`, options),
      agency_brands: (options) => CallService(GET, `${BASE_URL}/reports/agency_brands`, options),
    },
    customer: {
      get: (options) => CallService(GET, `${BASE_URL}/customer`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/customer`, options),
    },
    agency: {
      get: (options) => CallService(GET, `${BASE_URL}/agency/bycompany`, options),
      getbydomain: (options) => CallService(GET, `${BASE_URL}/agency/getbydomain`, options),
      get_app_setup: (options) => CallService(GET, `${BASE_URL}/agency/get_app_setup`, options),
      getworkflows: (options) => CallService(GET, `${BASE_URL}/agency/getworkflows`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/agency`, options),
      getProducts: (options) => CallService(GET, `${BASE_URL}/agency/getproducts`, options),
      getWorkflows: (options) => CallService(GET, `${BASE_URL}/agency/getworkflows`, options),
      update_by_company_id: (options) => CallService(PUT, `${BASE_URL}/agency/update_by_company_id`, options),
      getwhitelabel: (options) => CallService(POST, `${BASE_URL}/agency/getwhitelabel`, options),
      getAgency: (options) => CallService(GET, `${BASE_URL}/agency/`, options),
      GetChargelogs: (options) => CallService(GET, `${BASE_URL}/agency/chargelogs`, options),
    },
    profile: {
      get: (options) => CallService(GET, `${BASE_URL}/profile`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/profile`, options),
      create: (options) => CallService(POST, `${BASE_URL}/profile`, options),
    },
    chat: {
      get: (options) => CallService(GET, `${BASE_URL}/chat/`, options),
      getByAgency: (options) => CallService(GET, `${BASE_URL}/chat/getbyagency`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/chat/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/chat`, options),
      shareAgentChat: (options) => CallService(PUT, `${BASE_URL}/chat/share-agent-chat`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/chat/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/chat`, options),
      postonghl: (options) => CallService(POST, `${BASE_URL}/chat/postonghl`, options),
      fileDownload: (options) => CallService(GET, `${BASE_URL}/chat/assistants/files/download`, options),
    },
    assistant: {
      Get: (options) => CallService(GET, `${BASE_URL}/modalcreate`, options),
      create: (options) => CallService(POST, `${BASE_URL}/assistant`, options),
      Getassistant: (options) => CallService(GET, `${BASE_URL}/assistant`, options),
      GetIntegrations: (options) => CallService(GET, `${BASE_URL}/assistant/integrations`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/assistant`, options),
      Delete: (options) => CallService(DELETE, `${BASE_URL}/assistant`, options),
      Custom: (options) => CallService(POST, `${BASE_URL}/assistant/custom`, options),
      Getplugin: (options) => CallService(GET, `${BASE_URL}/assistant/getplugins`, options),
      GetFunctions: (options) => CallService(GET, `${BASE_URL}/assistant/functions`, options),
      GetAdminAssisatntandtemplate: (options) => CallService(GET, `${BASE_URL}/assistant/GetAdminAssisatntandtemplate`, options),
      getAccountlevelassistants: (options) => CallService(GET, `${BASE_URL}/assistant/getAccountlevelassistants`, options),
      pauseShareAgents: (options) => CallService(PUT, `${BASE_URL}/assistant/pause-agents`, options),
    },
    messages: {
      get: (options) => CallService(GET, `${BASE_URL}/messages`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/messages/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/messages`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/messages/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/messages`, options),
    },
    webhook: {
      get: (options) => CallService(GET, `${BASE_URL}/webhook/`, options),
      check_location: (options) => CallService(POST, `${BASE_URL}/webhook/check_location`, options),
      checkout: (options) => CallService(GET, `${BASE_URL}/webhook/checkout`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/webhook/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/webhook`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/webhook/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/webhook`, options),
    },
    tickets: {
      get: (options) => CallService(GET, `${BASE_URL}/tickets`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/tickets/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/tickets`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/tickets/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/tickets`, options),
    },
    comments: {
      get: (options) => CallService(GET, `${BASE_URL}/comments`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/comments/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/comments`, options),
    },
    docs: {
      get: (options) => CallService(GET, `${BASE_URL}/docs`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/docs/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/docs`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/docs/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/docs`, options),
    },
    docs_category: {
      get: (options) => CallService(GET, `${BASE_URL}/docs/category`, options),
      filter: (options) => CallService(GET, `${BASE_URL}/docs/category/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/docs/category`, options),
      delete: (options) => CallService(POST, `${BASE_URL}/docs/category/delete`, options),
      create: (options) => CallService(POST, `${BASE_URL}/docs/category`, options),
    },
    location: {
      get: (options) => CallService(GET, `${BASE_URL}/location`, options),
      user_locations: (options) => CallService(GET, `${BASE_URL}/location/user_locations`, options),
    },
    business: {
      get: (options) => CallService(GET, `${BASE_URL}/business`, options),
      by_agency: (options) => CallService(GET, `${BASE_URL}/business/by_agency`, options),
      by_location: (options) => CallService(GET, `${BASE_URL}/business/by_location`, options),
    },
    design: {
      get: (options) => CallService(GET, `${BASE_URL}/design`, options),
      create: (options) => CallService(POST, `${BASE_URL}/design`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/design`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/design`, options),
    },
    campaign: {
      get: (options) => CallService(GET, `${BASE_URL}/campaign`, options),
      create: (options) => CallService(POST, `${BASE_URL}/campaign`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/campaign`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/campaign`, options),
      passes: (options) => CallService(GET, `${BASE_URL}/campaign/passes`, options),
    },
    public: {
      get: (options) => CallService(GET, `${BASE_URL}/public`, options),
      enrollment: (options) => CallService(POST, `${BASE_URL}/public/enrollment`, options),
      enroll_now: (options) => CallService(POST, `${BASE_URL}/public/enrollnow`, options),
      get_enrollment: (options) => CallService(GET, `${BASE_URL}/public/enrollment`, options),
      pass: (options) => CallService(GET, `${BASE_URL}/public/pass`, options),
      passes: (options) => CallService(GET, `${BASE_URL}/public/passes`, options),
      subscriber: (options) => CallService(GET, `${BASE_URL}/public/subscriber`, options),
    },
    pass: {
      get: (options) => CallService(GET, `${BASE_URL}/pass`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/pass`, options),
    },
    growthtool: {
      get: (options) => CallService(GET, `${BASE_URL}/growthtool`, options),
      create: (options) => CallService(POST, `${BASE_URL}/growthtool`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/growthtool`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/growthtool`, options),
    },
    redemption: {
      redeem: (options) => CallService(POST, `${BASE_URL}/redemption`, options),
      giveaway: (options) => CallService(POST, `${BASE_URL}/redemption/giveaway`, options),
    },
    mailgun: {
      getdomains: (options) => CallService(GET, `${BASE_URL}/mailgun/emails`, options),
    },
    // ghl: {
    //   call   : (options) => CallService(POST, `${BASE_URL}/services/ghl`, options),
    //   oauth : (options) => CallService(GET, `${BASE_URL}/services/ghl/oauth/callback`, options),
    // },
    super_admin: {
      get: (options) => CallService(GET, `${BASE_URL}/super_admin/`, options),
      getproducts: (options) => CallService(GET, `${BASE_URL}/super_admin/getproducts`, options),
      add_team: (options) => CallService(GET, `${BASE_URL}/super_admin/add_team`, options),
      agencies: (options) => CallService(GET, `${BASE_URL}/super_admin/agencies`, options),
      customers: (options) => CallService(GET, `${BASE_URL}/super_admin/customers`, options),
    },
    apps: {
      get: (options) => CallService(GET, `${BASE_URL}/apps/`, options),
    },
    upsales: {
      makecharge: (options) => CallService(POST, `${BASE_URL}/upsales/makecharge`, options),
      get: (options) => CallService(GET, `${BASE_URL}/upsales`, options),
    },
    product: {
      get: (options) => CallService(GET, `${BASE_URL}/product`, options),
      create: (options) => CallService(POST, `${BASE_URL}/product`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/product`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/product`, options),
    },
    utils: {
      upload_image: (options) => CallService(POST, `${BASE_URL}/utils/upload/image`, options),
    },
    services: {
      ghl: {
        call_service: (options) => CallService(POST, `${BASE_URL}/services/ghl/`, options),
      },
    },
    ghl: {
      call: (options) => CallService(POST, `${BASE_URL}/services/ghl`, options),
      refresh_token: (options) =>
        CallService(POST, `${BASE_URL}/services/ghl/refresh_token`, options),
    },
    toneoptions: {
      Get: (options) => CallService(GET, `${BASE_URL}/toneoptions`, options),
    },
    translateoption: {
      Get: (options) => CallService(GET, `${BASE_URL}/translateoption`, options),
    },
    imgoptions: {
      Get: (options) => CallService(GET, `${BASE_URL}/imgoptions`, options),
    },
    channeloptions:
    {
      Get: (options) => CallService(GET, `${BASE_URL}/channeloptions`, options),
    },
    prompts: {
      createDocs: (options) => CallService(POST, `${BASE_URL}/prompts`, options),
      updateDocs: (options) => CallService(PUT, `${BASE_URL}/prompts`, options),
      Docs: (options) => CallService(POST, `${BASE_URL}/prompts`, options),
      get_filter: (options) => CallService(GET, `${BASE_URL}/prompts/filter`, options),
      get_admin_prompts: (options) => CallService(GET, `${BASE_URL}/prompts/filter/admin-prompts`, options),
      get_filter_cat: (options) => CallService(GET, `${BASE_URL}/prompts/category/filter`, options),
      managepromptsdata: (options) => CallService(GET, `${BASE_URL}/prompts/managepromptsdata`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/prompts/delete`, options),
      switchIdsManager: (options) => CallService(POST, `${BASE_URL}/prompts/switchIdsManager`, options),
      promptGenerator: (options) => CallService(POST, `${BASE_URL}/prompts/account/generate`, options),
    },
    saas: {
      agencysaas: (options) => CallService(GET, `${BASE_URL}/saas/agencysaas`, options),
      fetchPlanById: (options) => CallService(GET, `${BASE_URL}/saas/plan`, options)
    },
    aiTokenPlans: {
      list: (options) => CallService(GET, `${BASE_URL}/ai_token_plans`, options),
    },
    subscription: {
      getPaymentInfoByAgencyId: (options) => CallService(GET, `${BASE_URL}/subscriptions/agency/${options.agency_id}/${options.customer_id}`, options),
      getInvoicesByAgencyId: (options) => CallService(GET, `${BASE_URL}/subscriptions/agency/invoices/${options.agency_id}/${options.customer_id}`, options),
      getSubscriptionsBySubscriptionId: (options) => CallService(GET, `${BASE_URL}/subscriptions/get-subscription/${options.subscription_id}/${options.agency_id}`, options),
      updatePaymentMethodByAgencyId: (options) => CallService(PUT, `${BASE_URL}/subscriptions/agency/paymentmethod`, options),
      updateBillingInfoByStripeId: (options) => CallService(PUT, `${BASE_URL}/subscriptions/agency/billinginfo`, options),
      createSubscription: (options) => CallService(POST, `${BASE_URL}/subscriptions/create-subscription`, options),
      createCustomer: (options) => CallService(POST, `${BASE_URL}/subscriptions/create-customer`, options),
      cancelSubscription: (options) => CallService(PUT, `${BASE_URL}/subscriptions/cancel-subscription`, options),
      upgradeSubscription: (options) => CallService(PUT, `${BASE_URL}/subscriptions/upgrade-subscription`, options),
    },
    coupons: {
      applyCoupon: (options) => CallService(PUT, `${BASE_URL}/coupons/apply`, options),
    },
    webhook_config: {
      list: (options) => CallService(GET, `${BASE_URL}/webhook/configure`, options),
      create: (options) => CallService(POST, `${BASE_URL}/webhook/configure`, options),
      get_secret: (options) => CallService(GET, `${BASE_URL}/webhook/configure/${options.source_id}/secret`, options),
      toggle: (options) => CallService(PUT, `${BASE_URL}/webhook/configure/${options.source_id}`, options),
      delete: (options) => CallService(DELETE, `${BASE_URL}/webhook/configure/${options.source_id}`, options),
    },
    convoy: {
      add_webhook_to_task: (options) => CallService(POST, `${BASE_URL}/convoy/sources/${options.source_id}/tasks/${options.task_id}`, options),
    }

  };

  return APIs;
}

const useUploadImage = () => {
  const AppService = useAppServices();
  return ({ toaster, file, desiredPath }) => {
    const form = new FormData();
    form.append("image", file, file.name);
    return AppService.utils.upload_image({
      toaster,
      payload: form,
      query: `desiredPath=${desiredPath}`,
    });
  };
};

export { useAppServices, useCallService, useUploadImage };
